import Vue from 'vue'
import Router from 'vue-router'
// import Study from '@/pages/study'

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) { //防止多次点击页面重复
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/list'
    },
    {
      path: '/my',
      name: 'my',
      components: {
        default: () => import('@/pages/my'),
        footer: () => import('@/pages/footer'),
      }
    },
    {
      path: '/lingyong',//领用记录
      name: 'lingyong',
      components: {
        default: () => import('@/pages/lingyong'),
        footer: () => import('@/pages/footer'),
      }
    },
    {
      path: '/accessionRecord',//申请记录处理
      name: 'accessionRecord',
      components: {
        default: () => import('@/pages/accessionRecord'),
        footer: () => import('@/pages/footer'),
      }
    },
    {
      path: '/haocaichuli',//耗材处理
      name: 'haocaichuli',
      components: {
        default: () => import('@/pages/haocaichuli'),
        footer: () => import('@/pages/footer'),
      }
    },
    {
      path: '/list', //首页列表
      name: 'list',
      components: {
        default: () => import('@/pages/list'),
        footer: () => import('@/pages/footer'),

      }
    },
 
    {
      path: '/cart',//购物车
      name: 'cart',
      components: {
        default: () => import('@/pages/cart'),
        // footer: () => import('@/pages/footer'),

      }
    },
    {
      path: '/selectorganization',
      name: 'selectorganization',
      components: {
        default: () => import('@/pages/selectOrganization'),
        footer: () => import('@/pages/footer')

      }
    },
   
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js